import React, { useEffect, useRef, useState } from "react";
import Typography from "@mui/material/Typography";
import { CircularProgress, FormControl, MenuItem, Select } from "@mui/material";
import { CardActionArea } from "@mui/material";
import { FaAnglesLeft, FaAnglesRight, FaAngleLeft, FaBuilding } from "react-icons/fa6";
import { useDispatch } from "react-redux";
import { companies, companies_non_mask, deletemycompany, dropDowns, mycompanies } from "../store/reducers";
import Map from "./Map";
import Filter from "./Filter";
import FSC from "../assets/FSC.jpg";
import ATFS from "../assets/ATFS.png";
import AllMapAddress from "./AllMapAddress";
import newTab from "../assets/new-tab.jpg";
import PEFC from "../assets/PEFC.jpg";
import SFI from "../assets/SFI.png";
import { FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { IoCall } from "react-icons/io5";
import { IoIosMail } from "react-icons/io";
import MenuButton from "./MenuButton";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { toast } from "react-toastify";
import Detail from "./Detail";
import { decryptAndRetrieveData } from "./login/encript-decript";

function Companies({ myCompanyRoute, dragable }) {
  const [click, setclick] = useState(false);
  const [page, setpage] = useState(1);
  const [company, setcompany] = useState();
  const [selectcompany, setselectcompany] = useState();
  const [loading, setloading] = useState(false);
  const [index, setIndex] = useState(0);
  const user = decryptAndRetrieveData("isAuth", '123456789')

  console.log('login',user);
  
  

  const dispatch = useDispatch();

  const handledata = (e, data, index) => {
    e.preventDefault();
    setselectcompany(data);
    setIndex(index);
    setclick(true);
    navigate('/company-detail', { state: { data } })
  };

  const navigate = useNavigate();

  const handleEdit = (data) => {
    navigate("/add-company", { state: { data } });
  };
  const handleDelete = (data) => {
    console.log(data?.id)
    setloading(true);
    dispatch(deletemycompany({ id: data?.id })).then((res) => {
      console.log('res', res);

      if (res?.meta.requestStatus === "fulfilled") {


        const payload = {
          page: page,
        };
        dispatch(mycompanies(payload))
          .then((data) => {
            setcompany(data);
            setloading(false);
            toast.success(res?.payload)
          })
          .catch((err) => console.error(err));
      } else {
        toast.error(res?.payload)
      }

    })

  }

  const handleclose = () => {
    setclick(false);
  };

  const handleprevious = () => {
    setpage(page - 1 !== 0 ? page - 1 : 1);
  };
  const handlenext = () => {
    if (company?.payload?.length == 30) {
      setpage(page + 1);
    }
  };

  const handlenext1 = () => {
    if (company?.payload?.length == 10) {
      setpage(page + 1);
    }
  };

  const [filterData, setFilterData] = useState(null);

  useEffect(() => {
    if (!myCompanyRoute) {
      dispatch(dropDowns()).then((res) => {
        setFilterData(res.payload);
      });
    }
  }, []);

  const [filterPayload, setFilterPayload] = useState({});

  const [userCurrentLocation, setUserCurrentLocation] = useState({
    x: -1,
    y: -1,
  });

  useEffect(() => {

    setloading(true);

    if (myCompanyRoute) {
      const payload = {
        page: page,
      };
      dispatch(mycompanies(payload))
        .then((data) => {
          setcompany(data);
          setloading(false);
        })
        .catch((err) => console.error(err));
    } else {
      const payload = {
        page_size: 30,
        page: page,
        filters: {
          products_produced: filterPayload?.products_produced,
          products_purchased: filterPayload?.products_purchased,
          species: filterPayload?.species,
          company_name: filterPayload?.company_name,
          region: filterPayload?.region,
          equipments: filterPayload?.equipments,
          residue: filterPayload?.residue,
          services: filterPayload?.services,
          accept_bid_logs: filterPayload?.accept_bid_logs,
          certifications: filterPayload?.certifications,
          state: filterPayload?.state,
        },
        // sort: short,
        x: userCurrentLocation?.x,
        y: userCurrentLocation?.y,
      };
      dispatch(!user ? companies(payload): companies_non_mask(payload))
        .then((data) => {
          setcompany(data);
          setloading(false);
        })
        .catch((err) => console.error(err));
    }
  }, [page, filterPayload, userCurrentLocation]);

  const filter = (filterData) => {
    setFilterPayload(filterData);
  };

  const [showMore, setShowMore] = useState(false);

  const [border, setBorder] = useState(null);
  const highLighData = (address) => {
    setBorder(address);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [click]);

  const cardRefs = useRef([]);
  useEffect(() => {
    if (!myCompanyRoute) {
      company?.payload?.forEach((data, index) => {
        if (
          border ===
          `${data?.address}, ${data?.city}, ${data?.state}, ${data?.zip}` &&
          cardRefs.current[index]
        ) {
          cardRefs.current[index].scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      });
    }
  }, [border, company?.payload]);
  const [map, setmap] = useState(false);
  const [isCollapseOpen, setIsCollapseOpen] = useState(false);

  const handleToggle = (type) => {
    if (map === type && isCollapseOpen) {
      setIsCollapseOpen(false);
      setTimeout(() => setmap(null), 300);
    } else {
      setmap(type);
      setIsCollapseOpen(true);
    }
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isMobile1, setIsMobile1] = useState(window.innerWidth <= 991);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      setIsMobile1(window.innerWidth <= 991);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.7)", // Semi-transparent background
            zIndex: 1000, // Ensure loader stays on top
          }}
        >
          <CircularProgress style={{ color: "#4A5E00" }} />
        </div>
      )}

      <>
        <div className="d-flex w-100 position-relative">
          <div className="company-details-main">
            <div style={{ margin: "3em 2.2em 0em" }} className="com-div">

              <div className="d-flex justify-content-between rpf-title com">
                <div
                  className="d-flex"
                  style={{
                    alignItems: "center",
                    marginLeft: "0.7em",
                    marginBottom: "1em",
                  }}
                >
                  <Typography variant="h5">
                    {myCompanyRoute ? "My Companies" : "All Companies"}
                  </Typography>
                </div>

              </div>

            </div>

            <div
              className="d-flex companies-list overflow-hidden"
              style={{ margin: myCompanyRoute ? "2em 2em 2em 1.5em" : "" }}
            >
              {myCompanyRoute ? (
                <></>
              ) : !isMobile ? (
                <div className=" map-width1">
                  {company?.payload?.length > 0 && (
                    <div style={{ width: "100%" }} className="map-width">
                      <AllMapAddress
                        addresses={company.payload}
                        highLighData={highLighData}
                        userCurrentLocation={userCurrentLocation}
                        setUserCurrentLocation={setUserCurrentLocation}
                      />
                    </div>
                  )
                  }

                  <div style={{ marginTop: company?.payload?.length > 0 ? '3em' : '0em' }}>
                    <Filter data={filterData} filter={filter} setpage={setpage} />
                  </div>

                </div>
              ) : (
                <>
                  <div className="d-flex flex-row justify-content-between">
                    <div>
                      <button
                        style={{ marginLeft: "15px" }}
                        className="mob-btn btn btn-primary"
                        type="button"
                        onClick={() => handleToggle("Filter")}
                      >
                        Filter
                      </button>

                      <button
                        style={{ marginLeft: "5px" }}
                        className="mob-btn1 btn btn-primary"
                        type="button"
                        onClick={() => handleToggle("Map")}
                      >
                        Map
                      </button>

                      <div
                        className={`collapse filter-bottom-to-top ${isCollapseOpen ? "show" : ""}`}
                        id="filterCollapse"
                      >
                        <div
                          className="card card-body"
                          style={{
                            padding: map === "Map" ? "0px" : "",
                            paddingBottom: map === "Map" ? "25px" : "",
                          }}
                        >
                          {map === "Map" ? (
                            <>
                              {company?.payload?.length > 0 && (
                                <AllMapAddress
                                  addresses={company.payload}
                                  highLighData={highLighData}
                                  userCurrentLocation={userCurrentLocation}
                                  setUserCurrentLocation={setUserCurrentLocation}
                                />
                              )}
                            </>
                          ) : map === "Filter" ? (
                            <Filter
                              data={filterData}
                              filter={filter}
                              isMobile="true"
                              setpage={setpage}
                            />
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {!myCompanyRoute ?
                <div
                  className={`row card main-com ${myCompanyRoute ? "col-12 m-card" : "company-list"
                    }`}
                  style={{
                    border: "none",
                    display: "ruby",
                    margin: company?.payload?.length > 0 ? undefined : "0px !important",
                    width: company?.payload?.length > 0 ? undefined : "100%",
                  }}

                >
                  {company?.payload?.length > 0 ? (
                    company?.payload?.map((data, index) => {
                      return (<>
                        <div className='col-6 dynamic-list' style={{ marginBottom: '1.5em' }} onClick={(e) => handledata(e, data, index)}>
                          {/* <div className='d-flex' > */}
                            <div className="d-flex" style={{alignItems:'center'}}>
                              <FaBuilding style={{ color: '#A5BF45', cursor: 'pointer', marginRight: '0.2em', height: '1.5em', width: '1.5em' }} />

                              <Typography > <span style={{ textDecoration: 'underline', color: '#A5BF45', cursor: 'pointer' }}> {data.name}</span> {data.city} , {data.state}  </Typography>
                            </div>
                            {/* <Typography style={{ marginLeft: '0.2em' }}>{data.city} , {data.state} </Typography> */}

                          {/* </div> */}
                        </div>
                      </>
                      );
                    })
                  ) : (
                    <Typography style={{ textAlign: 'center' }}>No companies available.</Typography>
                  )}

                  {company?.payload?.length > 0 && (
                    <div
                      style={{
                        textAlign: "center",
                        background: "white",
                        padding: "20px",
                        margin: "1.5em 0",
                      }}
                    >
                      <span
                        style={{
                          cursor: page === 1 ? "not-allowed" : "pointer",
                          color: page === 1 ? "gray" : "black",
                          fontSize: "larger",
                        }}
                      >
                        {" "}
                        <FaAnglesLeft
                          style={{ marginRight: "1em" }}
                          onClick={handleprevious}
                        />{" "}
                      </span>

                      <span className="set-page-no">{page}</span>

                      <span
                        style={{
                          cursor:
                            company?.payload?.length < 30
                              ? "not-allowed"
                              : "pointer",
                          fontSize: "larger",
                          color:
                            company?.payload?.length < 30
                              ? "gray"
                              : "black",
                        }}
                      >
                        <FaAnglesRight
                          style={{ marginLeft: "1em" }}
                          onClick={handlenext}
                        />
                      </span>
                    </div>
                  )}

                </div> :
                <div
                  className={`row card main-com ${myCompanyRoute ? "col-12 m-card" : "col-8"
                    }`}
                  style={{
                    border: "none",
                    display: "ruby",
                  }}
                >
                  {company?.payload?.length > 0 ? (
                    company?.payload?.map((data, index) => {
                      return (
                        <div
                          ref={(el) => (cardRefs.current[index] = el)}
                          key={index}
                          // className="col-12 col-md-6 inner-card p-0 card-com"
                          className={`col-6 inner-card p-0 card-com ${myCompanyRoute ? "col-md-3" : "col-md-6"
                            }`}
                          style={{
                            border:
                              border === `${data?.complete_physical_address}`
                                ? "2px solid #A5BF45"
                                : "2px solid lightgray",
                            width: myCompanyRoute ? "" : showMore ? "42%" : "43%",
                            marginBottom: "2em",
                            marginLeft: '1em',
                            boxShadow: "0 4px 12px rgba(27,71,102,0.15)",
                            minHeight: "170px", // Adjust this as needed
                            maxHeight: "auto",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            alignItems: "stretch"
                          }}
                        >
                          <CardActionArea>
                            <div className="d-flex section-1 flex-column">
                              <div style={{ padding: "0.7rem", cursor: 'default' }}>
                                <div>
                                  <div>
                                    <div className="d-flex justify-content-between">
                                      <div>
                                      <span
                                        style={{
                                          fontSize: "20px",
                                          fontWeight: "500",
                                          cursor: 'pointer',
                                          width: '100%'
                                        }}
                                        onClick={(e) => handledata(e, data, index)}
                                      >
                                        {data.name}
                                         
                                      </span>
                                      {data.admin_verified !== true &&
                                      <span style={{marginLeft:'1em',backgroundColor:' rgb(255 105 97 / 48%) ',padding:'0.3em',borderRadius:'1em'}}>
                                      {data.admin_verified !== true && 'unverified'}
                                      </span>}
                                      </div>
                                      <div>
                                        {myCompanyRoute ? (
                                          <div className="d-flex">
                                            <FaEdit
                                              onClick={() => handleEdit(data)}
                                              style={{
                                                height: "1.5em",
                                                width: "1.5em",
                                                marginRight: '0.5em'
                                              }}
                                            />
                                            <RiDeleteBin6Fill
                                              onClick={() => handleDelete(data)}
                                              style={{
                                                height: "1.5em",
                                                width: "1.5em",
                                              }} /></div>
                                        ) : (
                                          <></>
                                        )}
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                      }}
                                    >
                                      <h6>
                                        <a
                                          href={data.company_contacts[0]?.website}
                                          style={{
                                            textDecoration: "none",
                                            color: "#707070",
                                          }}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          {data.company_contacts[0]?.website && (
                                            <img
                                              src={newTab}
                                              alt="newTab"
                                              height={"17px"}
                                              width={"17px"}
                                            />
                                          )}{" "}

                                        </a>
                                        {data.company_contacts[0]?.website}
                                      </h6>
                                    </div>
                                  </div>

                                  <div>
                                    <h6 style={{ display: 'flex' }}>
                                      <a
                                        style={{
                                          textDecoration: "none",
                                          color: "#707070",
                                        }}
                                        href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                                          `${data?.x},${data?.y}`
                                        )}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {data?.complete_physical_address && (
                                          <span
                                            style={{
                                              backgroundColor: "rgb(112, 112, 112)",
                                              color: "white",
                                              width: "21px",
                                              height: "21px",
                                              borderRadius: "50% 50% 50% 0",
                                              transform: "rotate(-45deg)",
                                              textAlign: "center",
                                              lineHeight: "22px",
                                              fontWeight: "bold",
                                              border: "2px solid white",
                                              fontSize: "14px",
                                              display: "inline-block",
                                            }}
                                          >
                                            <span
                                              style={{
                                                transform: "rotate(45deg)",
                                                display: "flex",
                                                paddingLeft: "3px",
                                                fontSize: "smaller",
                                              }}
                                            >
                                              {index + 1}
                                            </span>
                                          </span>
                                        )}

                                      </a>

                                      <span className="truncate-text" style={{
                                        display: "-webkit-box",
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                        WebkitLineClamp: 3,  // Limits to 3 lines
                                        whiteSpace: "normal",
                                        wordWrap: "break-word"
                                      }}>
                                        {data?.street_address}, {data?.city}, {data?.state}, {data?.zip}
                                      </span>

                                    </h6>
                                  </div>

                                  <div>
                                    <h6 className="d-flex">
                                      <a
                                        href={`tel:${data?.company_contacts[0]?.phone}`}
                                        style={{
                                          textDecoration: "none",
                                          color: "#707070",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        {data?.company_contacts[0]?.phone && (
                                          <i
                                            style={{ marginRight: "5px" }}
                                            className="fa fa-phone"
                                          ></i>
                                        )}

                                      </a>
                                      {data?.company_contacts[0]?.phone}{" "}
                                    </h6>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </CardActionArea>
                        </div>
                      );
                    })
                  ) : (
                    <Typography style={{ textAlign: 'center' }}>No companies available.</Typography>
                  )}


                  {company?.payload?.length && (
                    <div
                      style={{
                        textAlign: "center",
                        background: "white",
                        padding: "20px",
                        margin: "1.5em 0",
                      }}
                    >
                      <span
                        style={{
                          cursor: page === 1 ? "not-allowed" : "pointer",
                          color: page === 1 ? "gray" : "black",
                          fontSize: "larger",
                        }}
                      >
                        {" "}
                        <FaAnglesLeft
                          style={{ marginRight: "1em" }}
                          onClick={handleprevious}
                        />{" "}
                      </span>

                      <span className="set-page-no">{page}</span>

                      <span
                        style={{
                          cursor:
                            company?.payload?.length < 10
                              ? "not-allowed"
                              : "pointer",
                          fontSize: "larger",
                          color:
                            company?.payload?.length < 10
                              ? "gray"
                              : "black",
                        }}
                      >
                        <FaAnglesRight
                          style={{ marginLeft: "1em" }}
                          onClick={handlenext1}
                        />
                      </span>
                    </div>
                  )}

                </div>}
            </div>
          </div>

          {!isMobile1 && (
            <div
              id="sidemenu"
              className="sidemenu"
              style={{
                position: "absolute",
                right: "0",
                backgroundColor: "rgba(128, 128, 128, 0.15)",
                padding: "1em",
                // height : myCompanyRoute ? '70%' : '100%'
                height: "100%",
              }}
            >
              <MenuButton />
            </div>
          )}

        </div>
      </>

    </>
  );
}

export default Companies;
